import * as React from 'react';
import useLocation from '../hooks/useLocation';
import LocaleContext from '../contexts/LocaleContext';

const EU_COUNTRIES = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
];

export default function LocaleProvider({ children }: { children: React.ReactNode }) {
  const { location } = useLocation();

  const countryCode = location?.country_code || '';

  // In Stripe, we are currently registered for tax in the EU and the UK.
  // Note: the 'GB' country code covers all of the United Kingdom.
  const isTaxRegistered = EU_COUNTRIES.includes(countryCode) || countryCode === 'GB';

  const contextValue = React.useMemo(
    () => ({
      countryCode,
      isTaxRegistered,
    }),
    [countryCode, isTaxRegistered],
  );

  return <LocaleContext.Provider value={contextValue}>{children}</LocaleContext.Provider>;
}
